import ViewProfile from './view-profile';

export default ViewProfile;
